import { Box, Stack } from '@mui/material'
import React, { memo } from 'react'

import CopyrightTextWrapper from 'wrappers/CopyrightTextWrapper'
import PoweredByWrapper from 'wrappers/poweredBy/PoweredByWrapper'
import FooterLinks from './FooterLinks'

const Footer = () => {
  // multiLanguage: { languageLink, selectedLanguage, renderLanguagePopup }
  return (
    <Stack spacing={1} alignItems='center' sx={{ pb: 2 }}>
      <FooterLinks />
      <Box sx={{ mt: 2 }}>
        <CopyrightTextWrapper />
      </Box>
      <PoweredByWrapper />
    </Stack>
  )
}

export default memo(Footer)
